import React from "react";
import styled from "styled-components";
import Flex from "./Flex";
import Text from "./Text";

const LegendBlock = styled.span<{ blockColor: number }>`
  background-color: ${(props) =>
    [
      props.theme.colors.green,
      props.theme.colors.blue,
      props.theme.colors.pink,
      props.theme.colors.orange,
    ][props.blockColor]};
  border-radius: 4px;
  width: 18px;
  height: 18px;
  display: inline-block;
  margin-right: 6px;
`;

export type LegendProps = {
  items: string[];
};

export const Legend = ({ items }: LegendProps) => {
  return (
    <Flex
      border={1}
      borderRadius="6px"
      p={3}
      justifyContent="center"
      flexWrap={"wrap"}
      style={{ gap: 18 }}
    >
      {items.map((x, i) => (
        <Flex alignItems={"center"} key={i}>
          <LegendBlock blockColor={i} />{" "}
          <Text fontWeight={500} lineHeight={1}>
            {x}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};
